module.exports = __webpack_public_path__ + "static/img/SFU教室_1.f062c5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/SFU/SFU教室_1.png
// module id = t9e0
// module chunks = 0